var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGdoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09742 6.15003L4.31009 14.443L6.06471 17.4745L10.8502 9.18585L9.09742 6.15003ZM7.79701 18.4741H17.3651L19.1162 15.4399H9.54877L7.79701 18.4741ZM19.1109 13.4399L14.3252 5.1499H10.8294L15.6156 13.4399H19.1109ZM8.52 3.1499H15.48L22 14.4443L18.52 20.4741H5.49L2 14.4443L8.52 3.1499ZM12.0049 11.1859L10.7035 13.4399H13.3062L12.0049 11.1859Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdoc);
export default __webpack_public_path__ + "static/media/gdoc.e54219072444df193a30f908e070e7c8.svg";
export { ForwardRef as ReactComponent };